import React from "react";
import { Image } from "./../../ui-components/index.js";
import AvatarIcon from "../icons/AvatarIcon.js";
import styles from "../statics/mention-list-scss.js";
const MentionAvatar = ({ src, alt }) => {
  const containerId = `${src}-${alt}-parent`;
  return /* @__PURE__ */ React.createElement("div", null, src ? /* @__PURE__ */ React.createElement(
    Image,
    {
      containerId,
      containerProps: {
        containerId
      },
      className: styles.avatar,
      displayMode: "fill",
      width: 28,
      height: 28,
      uri: src,
      alt
    }
  ) : /* @__PURE__ */ React.createElement(AvatarIcon, { className: styles.avatar }));
};
var MentionAvatar_default = MentionAvatar;
export {
  MentionAvatar_default as default
};
//# sourceMappingURL=MentionAvatar.js.map
